import React from "react";
import { ProductCompareGridSSR } from "tsi-common-react/src/apps/product-compare/ProductCompareGridSSR/index";

import { templates } from "@reactivated";

export const Template = (
    props: templates.ProductCompareGridBlockTemplate,
): React.JSX.Element => (
    <ProductCompareGridSSR {...props} showFirstAvailablePrice />
);
